import { render, staticRenderFns } from "./PuzzleFencesPage.vue?vue&type=template&id=4b28789c"
import script from "./PuzzleFencesPage.vue?vue&type=script&lang=js"
export * from "./PuzzleFencesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports